import { fg } from '@atlassian/jira-feature-gating';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

type State = {
	enabled: boolean;
};

const DEFAULT_STATE: State = {
	enabled: false,
};

let state = Object.freeze(DEFAULT_STATE);

autoBeforeEachTest(() => {
	state = DEFAULT_STATE;
});

/**
 * @deprecated to be removed on cleanup of jfp-magma-ssr-streaming-cleanup
 */
export const enableStreaming = (): void => {
	if (fg('jfp-magma-ssr-streaming-cleanup')) {
		return;
	}
	if (state.enabled) {
		throw new Error('Enable Streaming: Streaming already enabled');
	}

	state = { ...state, enabled: true };
};

/**
 * @deprecated to be removed on cleanup of jfp-magma-ssr-streaming-cleanup
 */
export const isStreamingEnabled = (): boolean => {
	if (fg('jfp-magma-ssr-streaming-cleanup')) {
		return true;
	}
	return state.enabled;
};
